import React, { Suspense, lazy } from "react";
// import { Link } from "react-router-dom";
// import CompanyLogo from "../assets/logo-white.webp";
import "./header.css";
import ScrollArrow from "./scroll-arrow";
import Logo from "./logo-2";
// import Accessibility from "./AccessibilityWidget/components/AccessibilityWidget";
import Navbar from "./Navbar";
import ChatBot from "./ChatBot";
// import WhatsApp from "./WhatsApp/WhatsApp";
const Accessibility= lazy(() =>
  import("./AccessibilityWidget/components/AccessibilityWidget")
);


export default function Header() {
  return (
    <div style={{ width: "100%", position: "relative" }}>
      {/* <Link to="/" className="link">
        <img 
          src="https://hirdaramani-microsite.sgp1.digitaloceanspaces.com/images/logo-white.webp"
          alt="Company Logo" 
          className="company-logo" 
          loading="eager" 
          fetchpriority="high"
        />
      </Link> */}
      <Navbar />
      <Logo />
      <ScrollArrow />
      {/* <Accessibility /> */}
      <Suspense fallback={null}>
        <Accessibility />
      </Suspense>
      <ChatBot />
      {/* <WhatsApp /> */}
    </div>
  );
}
